import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from '../Drone.module.scss';
import metadata from './DronesActivitiesComponent.metadata.json5';

function DronesActivitiesComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('DronesActivitiesComponent');
    const modelVM = _.get(submissionVM, pathUpdated);

    modelVM.value.isValidationReq = true;

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        lisallothusenotintdesFie: {
            visible: !_.isUndefined(modelVM.value.othFie)
                && modelVM.value.othFie === true
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

DronesActivitiesComponent.propTypes = wizardProps;
export default withRouter(DronesActivitiesComponent);
